import { Box } from '@mui/material'
import React, { Dispatch } from 'react'
import { BookingType } from '../../../../api/models/Common/JyrneyEnums'
import carshr from '../../../../assets/icon/Icon-carshr.svg'
import coach from '../../../../assets/icon/Icon-coach.svg'
import scooter from '../../../../assets/icon/Icon-scooter.svg'
import taxi from '../../../../assets/icon/Icon-taxi.svg'
import JourneyTypeButton from '../../../Bookings/JourneyTypeButton/JourneyTypeButton'

interface Props {
  operations?: Array<string>
  setActiveSelection: Dispatch<React.SetStateAction<string | undefined>>
}

const getIcon = (type: string) => {
  if (type === 'Taxi') return taxi
  if (type === 'Coach') return coach
  if (type === 'MicroMobility') return scooter
  if (type === 'CarRental') return carshr
  return taxi
}
const getEnumKeyByEnumValue = (myEnum: any, enumValue: any) => {
  let keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue)
  return keys.length > 0 ? keys[0] : ''
}

const services = ['Taxi']

export const OperationsSelector = (props: Props) => {
  const { operations = services, setActiveSelection } = props

  const handleSelect = (value: string) => {
    setActiveSelection(value)
  }

  const TypeButton = (props: { bookingType: BookingType }) => {
    const { bookingType } = props
    const key = getEnumKeyByEnumValue(BookingType, bookingType)
    return (
      <JourneyTypeButton
        buttonName={bookingType}
        buttonIcon={getIcon(key)}
        onClick={() => handleSelect(key)}
        active={operations ? operations.includes(key) : false}
        label={''}
      />
    )
  }

  return (
    <Box
      component="div"
      sx={{
        width: '70%',
        display: 'flex',
        gap: '20px',
      }}
    >
      <TypeButton bookingType={BookingType.Taxi} />
      <TypeButton bookingType={BookingType.Coach} />
      <TypeButton bookingType={BookingType.CarRental} />
      <TypeButton bookingType={BookingType.MicroMobility} />
    </Box>
  )
}
export default OperationsSelector
